import React from 'react';
import { Button } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * with isActive set button turns into a green bar
 * otherwise it is a normal Button
 * Старый компонент
 * Использовать новый из ui-kit
 * @todo задача ES-4749
 * @deprecated
 */
export default function ReactiveButton({
  children,
  className,
  href,
  isActive,
  isDisabled,
  isLarge,
  isWide,
  onClick,
  theme,
  type,
}) {
  const TagName = href ? 'a' : 'button';

  return isActive ?
      <TagName
        className={cx('component', { large: isLarge, wide: isWide }, className)}
        href={href}
        onClick={onClick}
      >
        <span>{children}</span>
      </TagName>
    : <Button
        className={[{ big: isLarge }, cx('baseComponent', className)]}
        color={theme}
        disabled={isDisabled}
        href={href}
        onClick={onClick}
        type={type}
        wide={isWide}
      >
        {children}
      </Button>;
}

ReactiveButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLarge: PropTypes.bool,
  isWide: PropTypes.bool,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(['light']),
  type: PropTypes.oneOf(['submit']),
};
